import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RealtorBookingStore } from './types';

const initialState: RealtorBookingStore = {
  totalElements: 0,
  totalPages: 0,
  view: {
    visible: false
  }
};

const realtorBookingSlice = createSlice({
  initialState,
  name: 'realtor-booking-slice',
  reducers: {
    setRealtorBookingTotalItems: (state, actions: PayloadAction<Omit<RealtorBookingStore, 'view'>>) => {
      state.totalElements = actions.payload.totalElements;
      state.totalPages = actions.payload.totalPages;
    },
    setRealtorBookingView: (state, actions: PayloadAction<RealtorBookingStore['view']>) => {
      state.view = actions.payload;
    }
  }
});

export const realtorBookingReducer = realtorBookingSlice.reducer;
export const { setRealtorBookingTotalItems, setRealtorBookingView } = realtorBookingSlice.actions;
